import { get, post } from './../Config/config';


export const Document = {
    get: (data) => get('/hr/documents', { params: data }),
    add: (data) => post('/hr/documents/store', data),
}